import { render, staticRenderFns } from "./CaseInstallmentPlan.vue?vue&type=template&id=f4f0a28a&"
import script from "./CaseInstallmentPlan.vue?vue&type=script&lang=js&"
export * from "./CaseInstallmentPlan.vue?vue&type=script&lang=js&"
import style0 from "./CaseInstallmentPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports